/* eslint-disable import/prefer-default-export */
import { helpers } from 'vuelidate/lib/validators';

// Require lower case, upper case, number, symbol, and at least 8 characters.
export const passwordRule = helpers.regex('passwordRule', /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^ a-zA-Z0-9])(?=.{8,})/);
